import styled from "@emotion/styled";
import { symbol } from "prop-types";

export const Container = styled.div`
  min-width: 1140px;
  display: flex;
  padding: 0px 20px 80px 20px;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  flex: 1 0 0;
  align-self: stretch;

  .top-section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    align-self: stretch;
  }
  .tab-container {
    display: flex;
    align-items: center;
    align-self: stretch;
    border-bottom: 1px solid var(--alias-color-line-normal);
  }
`;

export const UpperSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const TabBar = styled.div`
  display: flex;
  padding: 0px 24px;
  align-items: flex-end;
  gap: 20px;
  cursor: pointer;
  flex: 1 0 0;
`;

export const TabItem = styled.div<{ selected: boolean }>`
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;

  ${(props) => props.selected && `border-bottom: 2px solid var(--alias-color-primary-normal);`}
`;

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const FilterContainer = styled.div`
  display: flex;
  padding: 0px 20px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`;

export const DateFilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
`;

export const MineRsvCheckbox = styled.div`
  display: flex;
  padding: 0px 4px;
  align-items: center;
  gap: 4px;
`;

export const BottomSection = styled.div`
  position: relative;
  display: flex;
  padding: 0px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 48px;
  flex: 1 0 0;
  align-self: stretch;
  flex: 1;
`;

export const CardListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 100%;
`;

export const EmptyContinaer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
